(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cm-about"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.cm-story-video').forEach((wrapper) => {
  const video = wrapper.querySelector('video');
  const button = wrapper.querySelector('button');
  video.controls = false;
  button.addEventListener('click', () => {
    video.controls = true;
    video.play().then(() => { button.hidden = true; }).catch(() => { button.hidden = true; });
  });
  video.addEventListener('play', () => { button.hidden = true; document.querySelectorAll('.cm-about-page video').forEach((other) => { if (other !== video) other.pause(); }); });
  video.addEventListener('ended', () => { button.hidden = false; });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cm-crew"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.cm-crew').forEach(section => {
  const previews = [...section.querySelectorAll('.cm-crew-preview')];
  const toggle = section.querySelector('.cm-crew-preview-toggle');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const visible = new Set();
  let active = null;
  let timer;
  let nextIndex = 0;
  let paused = false;
  let modalOpen = false;
  const stopPreview = () => {
    window.clearTimeout(timer);
    active = null;
    previews.forEach(video => {
      video.pause();
      video.closest('.cm-crew-media').removeAttribute('data-preview-active');
    });
  };
  const startNext = () => {
    if (paused || modalOpen || reducedMotion.matches || document.hidden || !visible.size || active) return;
    let video;
    for (let offset = 0; offset < previews.length; offset++) {
      const index = (nextIndex + offset) % previews.length;
      if (visible.has(previews[index])) {
        video = previews[index];
        nextIndex = (index + 1) % previews.length;
        break;
      }
    }
    if (!video) return;
    active = video;
    video.muted = true;
    video.defaultMuted = true;
    video.volume = 0;
    video.currentTime = 0;
    video.play().then(() => {
      if (active !== video || paused || modalOpen || reducedMotion.matches || document.hidden) {
        video.pause();
        return;
      }
      video.closest('.cm-crew-media').setAttribute('data-preview-active', '');
      timer = window.setTimeout(() => { stopPreview(); startNext(); }, 5000);
    }).catch(() => {
      if (active === video) stopPreview();
    });
  };
  if (previews.length && 'IntersectionObserver' in window) {
    toggle.hidden = reducedMotion.matches;
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const video = entry.target.querySelector('.cm-crew-preview');
        if (entry.isIntersecting && entry.intersectionRatio >= 0.35) visible.add(video);
        else visible.delete(video);
      });
      if (active && !visible.has(active)) stopPreview();
      startNext();
    }, { threshold: [0, 0.35] });
    previews.forEach(video => observer.observe(video.closest('.cm-crew-media')));
    toggle.addEventListener('click', () => {
      paused = !paused;
      toggle.setAttribute('aria-pressed', String(paused));
      toggle.textContent = paused ? 'Starta förhandsvisningar' : 'Pausa förhandsvisningar';
      if (paused) stopPreview();
      else startNext();
    });
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) stopPreview();
      else startNext();
    });
    reducedMotion.addEventListener('change', () => {
      toggle.hidden = reducedMotion.matches;
      stopPreview();
      startNext();
    });
  }
  section.querySelectorAll('.cm-crew-media').forEach(button => {
    const dialog = document.getElementById(button.getAttribute('aria-controls'));
    button.addEventListener('click', () => {
      modalOpen = true;
      stopPreview();
      dialog.showModal();
    });
    dialog.querySelector('.cm-crew-close').addEventListener('click', () => dialog.close());
    dialog.addEventListener('close', () => {
      dialog.querySelectorAll('video').forEach(video => video.pause());
      modalOpen = false;
      button.focus();
      startNext();
    });
    dialog.addEventListener('click', event => {
      if (event.target === dialog) {
        const box = dialog.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cm-home-a"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.cm-main-nav').forEach(nav => {
  const groups = [...nav.querySelectorAll('details.cm-nav-group')];
  groups.forEach(group => {
    group.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') { groups.forEach(other => { if (other !== group) other.open = false; }); group.open = true; } });
    group.addEventListener('pointerleave', event => { if (event.pointerType === 'mouse' && !group.contains(document.activeElement)) group.open = false; });
    group.addEventListener('toggle', () => { if (group.open) groups.forEach(other => { if (other !== group) other.open = false; }); });
    group.addEventListener('keydown', event => { if (event.key === 'Escape') { group.open = false; group.querySelector('summary').focus(); } });
    group.addEventListener('focusout', event => { if (!group.contains(event.relatedTarget)) group.open = false; });
  });
});

document.querySelectorAll('.cm-animation-toggle').forEach(button => {
  button.addEventListener('click', () => {
    const img = button.closest('.cm-photo-tile-wrap').querySelector('.cm-booking-animation img');
    const paused = button.getAttribute('aria-pressed') !== 'true';
    img.src = paused ? img.dataset.poster : img.dataset.animation;
    button.setAttribute('aria-pressed', String(paused));
    button.textContent = paused ? 'Spela animation' : 'Pausa animation';
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cm-logo-banner"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.cm-logo-banner__intro').forEach((intro) => {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  const link = intro.closest('a');
  const homeLink = link.classList.contains('cm-logo-banner__link--home');
  const key = 'cm-bike-intro-seen';
  const image = intro.querySelector('img');
  let timer;
  let playing = false;
  const play = () => {
    if (playing) return;
    playing = true;
    image.onload = () => {
      intro.hidden = false;
      window.clearTimeout(timer);
      timer = window.setTimeout(() => { intro.hidden = true; playing = false; }, 3850);
    };
    image.onerror = () => { intro.hidden = true; playing = false; };
    image.src = '';
    image.src = image.dataset.src;
  };
  if (homeLink) {
    link.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') play(); });
    link.addEventListener('focus', play);
  }
  let seen = false;
  try { seen = Boolean(sessionStorage.getItem(key)); } catch (error) {}
  if (homeLink) {
    play();
  } else if (!seen) {
    play();
    try { sessionStorage.setItem(key, '1'); } catch (error) {}
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cm-newsletter"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.cm-newsletter-page').forEach((section) => {
  const dialog = section.querySelector('.cm-newsletter-zoom');
  const triggers = section.querySelectorAll('.cm-newsletter-full, .cm-newsletter-pdf-cover');
  if (!dialog || !triggers.length) return;
  let ownsEntry = false;
  const update = () => {
    if (location.hash === '#' + dialog.id) {
      const reader = dialog.querySelector('.cm-newsletter-pdf-reader');
      if (reader && !reader.querySelector('object')) {
        const pdf = document.createElement('object');
        pdf.type = 'application/pdf';
        pdf.data = reader.dataset.pdfUrl + '#view=FitH';
        pdf.setAttribute('aria-label', reader.dataset.pdfTitle);
        const fallback = reader.querySelector('p');
        if (fallback) pdf.append(fallback);
        reader.append(pdf);
      }
      if (!dialog.open) dialog.showModal();
    } else if (dialog.open) dialog.close();
  };
  triggers.forEach(trigger => trigger.addEventListener('click', () => { ownsEntry = location.hash !== '#' + dialog.id; }));
  const close = () => {
    if (ownsEntry && location.hash === '#' + dialog.id) {
      ownsEntry = false;
      history.back();
    } else {
      history.replaceState(null, '', location.pathname + location.search);
      dialog.close();
    }
  };
  dialog.querySelector('button').addEventListener('click', close);
  dialog.addEventListener('cancel', (event) => { event.preventDefault(); close(); });
  window.addEventListener('hashchange', update);
  section.querySelectorAll('.cm-newsletter-download').forEach(link => {
    link.addEventListener('click', async event => {
      event.preventDefault();
      if (link.getAttribute('aria-busy') === 'true') return;
      link.setAttribute('aria-busy', 'true');
      const status = section.querySelector('.cm-newsletter-download-status');
      status.hidden = true;
      try {
        const response = await fetch(link.href, { credentials: 'omit' });
        if (!response.ok) throw new Error('PDF download failed');
        const blob = await response.blob();
        const url = URL.createObjectURL(blob);
        const download = document.createElement('a');
        download.href = url;
        download.download = link.download;
        document.body.append(download);
        download.click();
        download.remove();
        window.setTimeout(() => URL.revokeObjectURL(url), 60000);
      } catch {
        status.hidden = false;
        if (!dialog.open) {
          ownsEntry = true;
          location.hash = dialog.id;
        }
      } finally {
        link.removeAttribute('aria-busy');
      }
    });
  });
  update();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cm-partners"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.cm-partners').forEach(section => {
  const button = section.querySelector('.cm-partners__toggle');
  button.addEventListener('click', () => {
    const paused = section.dataset.paused !== 'true';
    section.dataset.paused = String(paused);
    button.setAttribute('aria-pressed', String(paused));
    button.textContent = paused ? button.dataset.playLabel : button.dataset.pauseLabel;
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cm-service"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.cm-service').forEach((root) => {
  const data = JSON.parse(root.querySelector('.cm-service-data').textContent);
  const today = new Intl.DateTimeFormat('sv-SE', { timeZone: 'Europe/Stockholm', year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date());
  const days = data.days.filter(d => /^\d{4}-\d{2}-\d{2}$/.test(d.date) && d.date >= today).sort((a,b) => a.date.localeCompare(b.date));
  const grid = root.querySelector('.cm-service-day-grid');
  const pay = root.querySelector('.cm-service-pay');
  const error = root.querySelector('.cm-service-error');
  const summary = root.querySelector('.cm-service-summary');
  let page = 0, selectedService = null, selectedDay = null;
  const date = d => new Date(d + 'T12:00:00');
  const dateLabel = d => new Intl.DateTimeFormat('sv-SE', { weekday: 'short', day: 'numeric', month: 'short' }).format(date(d)).replace(/\.$/,'');
  const money = n => new Intl.NumberFormat('sv-SE', { style: 'currency', currency: 'SEK', maximumFractionDigits: 0 }).format(n/100);
  const ready = day => {
    const d = date(day); const result = [];
    while (result.length < 2) { d.setDate(d.getDate()+1); if (![0,6].includes(d.getDay())) result.push(new Intl.DateTimeFormat('sv-SE',{day:'numeric',month:'short'}).format(d).replace(/\.$/,'')); }
    return result.join(' eller ');
  };
  const setStep = step => {
    root.dataset.step = step;
    root.querySelectorAll('[data-step-target]').forEach(button => {
      if (button.dataset.stepTarget === String(step)) button.setAttribute('aria-current','step'); else button.removeAttribute('aria-current');
    });
  };
  function update() {
    summary.replaceChildren();
    const main = document.createElement('strong');
    main.textContent = selectedService ? selectedService.dataset.name + ' · ' + (selectedService.dataset.from === 'true' ? 'fr. ' : '') + money(Number(selectedService.dataset.price)) : 'Välj service';
    const detail = document.createElement('span');
    detail.textContent = selectedDay ? 'Inlämning: ' + dateLabel(selectedDay.date) + '. Klar: ' + ready(selectedDay.date) + '.' : 'Välj en inlämningsdag.';
    summary.append(main, detail);
    pay.disabled = !(selectedService && selectedDay);
    root.querySelector('.cm-service-next').disabled = !selectedService;
    error.hidden = true;
  }
  function renderDays() {
    grid.replaceChildren();
    const visible = days.slice(page*5,page*5+5);
    root.querySelector('.cm-service-empty').hidden = days.some(day => day.left > 0);
    root.querySelector('.cm-service-range').textContent = visible.length ? dateLabel(visible[0].date) + ' – ' + dateLabel(visible[visible.length-1].date) : '';
    root.querySelector('[data-week="-1"]').disabled = page === 0;
    root.querySelector('[data-week="1"]').disabled = (page+1)*5 >= days.length;
    visible.forEach(day => {
      const button = document.createElement('button'); button.type = 'button';
      button.className = 'cm-service-day'; button.disabled = day.left <= 0;
      button.setAttribute('aria-pressed',String(selectedDay?.id === day.id));
      button.setAttribute('aria-label',dateLabel(day.date) + (day.left > 0 ? ', ' + day.left + ' platser kvar' : ', fullbokad'));
      const name = document.createElement('span');name.textContent = new Intl.DateTimeFormat('sv-SE',{weekday:'short'}).format(date(day.date));
      const number = document.createElement('strong');number.textContent = date(day.date).getDate();
      const left = document.createElement('small');left.textContent = day.left > 0 ? day.left + ' kvar' : 'Fullt';
      button.append(name,number,left);
      button.addEventListener('click',() => { selectedDay = day; renderDays(); update(); });grid.append(button);
    });
  }
  root.querySelectorAll('input[type="radio"]').forEach(input => input.addEventListener('change',() => { selectedService = input; update(); }));
  root.querySelectorAll('[data-step-target]').forEach(button => button.addEventListener('click',() => setStep(button.dataset.stepTarget)));
  root.querySelector('.cm-service-next').addEventListener('click',() => setStep(2));
  root.querySelectorAll('[data-week]').forEach(button => button.addEventListener('click',() => { page += Number(button.dataset.week); renderDays(); }));
  pay.addEventListener('click',async () => {
    if (!selectedService || !selectedDay || pay.disabled) return;
    pay.disabled = true; pay.setAttribute('aria-busy','true');pay.textContent = 'Går till kassan…';
    try {
      const response = await fetch(data.cartAdd,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:Number(selectedService.value),quantity:1,properties:{'Inlämning':dateLabel(selectedDay.date),'Klar att hämta':ready(selectedDay.date)}},{id:selectedDay.id,quantity:1}]})});
      if (!response.ok) throw new Error('booking');
      window.location.assign(data.checkout);
    } catch (e) {
      error.hidden = false;error.textContent = 'Bokningen kunde inte fortsätta. Dagen kan ha blivit fullbokad. Uppdatera sidan och försök igen.';
      pay.disabled = false;pay.removeAttribute('aria-busy');pay.textContent = 'Fortsätt till kassan';
    }
  });
  renderDays();update();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cm-shop"] && !Shopify.designMode) return;
  try {
    
function initCmShop(root){root.querySelectorAll('.cm-shop-nav:not([data-ready])').forEach(nav=>{nav.dataset.ready='true';const groups=[...nav.querySelectorAll('.cm-mega')];groups.forEach(group=>{const closeOthers=()=>groups.forEach(other=>{if(other!==group)other.open=false});group.querySelector('summary').addEventListener('click',event=>{if(event.pointerType==='mouse'&&window.matchMedia('(min-width:601px)').matches){event.preventDefault();closeOthers();group.open=true}});group.addEventListener('pointerenter',event=>{if(event.pointerType==='mouse'&&window.matchMedia('(min-width:601px)').matches){closeOthers();group.open=true}});group.addEventListener('pointerleave',event=>{if(event.pointerType==='mouse'&&!group.contains(document.activeElement))group.open=false});group.addEventListener('toggle',()=>{if(group.open)closeOthers()});group.addEventListener('keydown',event=>{if(event.key==='Escape'){group.open=false;group.querySelector('summary').focus()}});group.addEventListener('focusout',event=>{if(!group.contains(event.relatedTarget))group.open=false})})})}initCmShop(document);document.addEventListener('shopify:section:load',event=>initCmShop(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
